(() => {
  'use strict';
  function client(root) {
    const url = new URL(root.dataset.endpoint);
    if (url.protocol !== 'https:' || url.username || url.password) throw new Error('Nieprawidłowy adres obsługi opinii.');
    return async (path, data) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(url.href.replace(/\/$/, '') + '/reviews/' + path, {
          method: 'POST', mode: 'cors', credentials: 'omit',
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data), signal: controller.signal
        });
        let result;
        try { result = await response.json(); } catch (_) { throw new Error('Nie udało się odczytać odpowiedzi. Spróbuj ponownie.'); }
        if (!response.ok) throw new Error(result.error || result.message || 'Nie udało się połączyć. Spróbuj ponownie.');
        return result;
      } catch (error) {
        if (error.name === 'AbortError' || error instanceof TypeError) throw new Error('Połączenie zostało przerwane. Spróbuj ponownie.');
        throw error;
      } finally { clearTimeout(timer); }
    };
  }
  let services = {};
  function updateServices() {
    document.querySelectorAll('[data-review-form] select[name=service]').forEach(select => {
      const selected = select.value;
      Object.entries(services).forEach(([handle, title]) => {
        if (!Array.from(select.options).some(option => option.value === handle)) select.add(new Option(title, handle));
      });
      select.value = selected;
    });
  }
  function initForm(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-review-form]'), status = root.querySelector('[data-review-status]');
    const submit = form.querySelector('[type=submit]');
    let api, requestId = '', requestBody = '', sent = false;
    try { api = client(root); } catch (_) {
      status.textContent = 'Formularz jest chwilowo niedostępny. Napisz na zboostowani.kontakt@gmail.com.'; return;
    }
    function message(text, error = false) { status.textContent = text; status.dataset.error = String(error); }
    function id() {
      const bytes = new Uint8Array(16); crypto.getRandomValues(bytes);
      return Array.from(bytes, x => x.toString(16).padStart(2, '0')).join('');
    }
    submit.disabled = false; updateServices();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submit.disabled || sent || !form.reportValidity()) return;
      const data = new FormData(form);
      const body = {
        author: String(data.get('author') || '').trim(), email: String(data.get('email') || '').trim(),
        order_number: String(data.get('order_number') || '').trim(), service: data.get('service'),
        rating: Number(data.get('rating')), body: String(data.get('body') || '').trim(),
        consent: data.get('consent') === 'on', website: data.get('website') || ''
      };
      const encoded = JSON.stringify(body);
      if (!requestId || requestBody !== encoded) { requestId = id(); requestBody = encoded; }
      submit.disabled = true; submit.textContent = 'Wysyłanie opinii…'; message('Zapisujemy opinię.');
      try {
        const result = await api('submit', { ...body, request_id: requestId });
        if (result.ok !== true) throw new Error('Serwer nie potwierdził zapisu. Spróbuj ponownie.');
        sent = true; form.reset(); message(result.message); submit.textContent = 'Opinia wysłana do sprawdzenia';
      } catch (error) {
        message(error.message + ' Treść pozostaje w formularzu.', true);
        submit.disabled = false; submit.textContent = 'Wyślij opinię do sprawdzenia';
      }
    });
  }
  function node(tag, text, className) {
    const element = document.createElement(tag); element.textContent = text;
    if (className) element.className = className;
    return element;
  }
  function card(review) {
    const article = node('article', '', 'zb-review-card'); article.dataset.reviewId = String(review.id);
    const service = node('a', review.service_title, 'zb-service-tag');
    service.href = '/products/' + encodeURIComponent(review.service); article.append(service);
    const header = node('div', '', 'zb-review-header'); header.append(node('span', review.author, 'zb-review-author'));
    if (review.verified_purchase) header.append(node('span', '✓ Zweryfikowana przez zespół', 'zb-verified-badge'));
    const time = node('time', review.date, 'zb-review-date'); time.dateTime = review.date; header.append(time); article.append(header);
    const rating = Math.max(1, Math.min(5, Number(review.rating) || 1));
    const stars = node('div', '', 'zb-stars'); stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', 'Ocena: ' + rating + ' na 5');
    const icons = node('span', '★'.repeat(rating) + '☆'.repeat(5 - rating)); icons.setAttribute('aria-hidden', 'true'); stars.append(icons); article.append(stars);
    article.append(node('p', review.body, 'zb-review-body'));
    if (review.reward_disclosed) article.append(node('small', 'Opinia w programie rabatowym 5% — rabat niezależny od oceny.', 'zb-review-reward'));
    return article;
  }
  function initList(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-unified-reviews]'), nav = root.querySelector('[data-review-pagination]');
    const status = root.querySelector('[data-list-status]'), retry = root.querySelector('[data-list-retry]');
    const summary = document.getElementById('zb-rating-summary');
    const legacy = Array.from(root.querySelector('[data-review-archive]').content.querySelectorAll('.zb-review-card'));
    const legacySum = legacy.reduce((sum, item) => sum + Number(item.querySelector('.zb-stars').getAttribute('aria-label').match(/\d+/)[0]), 0);
    let api, page = 1, newTotal = 0, newSum = 0, loading = false, connected = false;
    try { api = client(root); } catch (_) { /* Static reviews remain usable. */ }
    const pageSize = 15;
    function pages() { return Math.max(1, Math.ceil((legacy.length + newTotal) / pageSize)); }
    function render(rows) {
      const offset = (page - 1) * pageSize;
      const start = Math.max(0, offset - newTotal);
      grid.replaceChildren(...rows.map(card), ...legacy.slice(start, start + pageSize - rows.length).map(item => item.cloneNode(true)));
      if (summary) {
        const count = legacy.length + newTotal;
        const average = count ? (legacySum + newSum) / count : 0;
        summary.textContent = 'Średnia ocen: ' + average.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '/5 · Liczba opinii: ' + count;
      }
      nav.replaceChildren();
      const last = pages();
      const numbers = new Set([1, last, page - 1, page, page + 1]);
      let previous = 0;
      Array.from(numbers).filter(n => n >= 1 && n <= last).sort((a, b) => a - b).forEach(n => {
        if (previous && n - previous > 1) nav.append(node('span', '…'));
        const button = node('button', String(n), 'zb-page-btn' + (n === page ? ' active' : ''));
        button.type = 'button'; button.disabled = loading; button.setAttribute('aria-label', 'Strona opinii ' + n);
        if (n === page) button.setAttribute('aria-current', 'page');
        button.addEventListener('click', () => { if (n !== page) load(n, true); });
        nav.append(button); previous = n;
      });
    }
    async function load(target = page, scroll = false) {
      if (loading) return;
      loading = true; retry.hidden = true; grid.setAttribute('aria-busy', 'true');
      nav.querySelectorAll('button').forEach(button => { button.disabled = true; });
      try {
        if (!api) throw new Error();
        const result = await api('list', { offset: (target - 1) * pageSize, limit: pageSize });
        if (!Array.isArray(result.reviews) || !Number.isInteger(result.total) || !Number.isInteger(result.rating_sum)) throw new Error();
        newTotal = result.total; newSum = result.rating_sum; connected = true;
        // Moderation can shrink the list while someone is browsing its last page.
        if (target > pages()) {
          target = pages();
          const corrected = await api('list', { offset: (target - 1) * pageSize, limit: pageSize });
          if (!Array.isArray(corrected.reviews)) throw new Error();
          result.reviews = corrected.reviews;
        }
        page = target; loading = false; render(result.reviews); status.textContent = '';
        services = result.services || {}; updateServices();
      } catch (_) {
        loading = false;
        if (!connected) { newTotal = 0; newSum = 0; page = Math.min(target, pages()); render([]); }
        status.textContent = 'Nie udało się odświeżyć opinii. Wyświetlamy dostępną listę — możesz ponowić wczytanie.';
        retry.hidden = false;
      } finally {
        grid.setAttribute('aria-busy', 'false'); nav.querySelectorAll('button').forEach(button => { button.disabled = false; });
        if (scroll) root.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    }
    render([]); retry.addEventListener('click', () => load(page));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
      }, { rootMargin: '200px' }); observer.observe(root);
    } else load();
  }
  function boot() {
    document.querySelectorAll('[data-zb-reviews]').forEach(initForm);
    document.querySelectorAll('[data-zb-review-list]').forEach(initList);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
